import { render, staticRenderFns } from "./ProviderTableSelection.vue?vue&type=template&id=8fe74f44"
import script from "./ProviderTableSelection.vue?vue&type=script&lang=js"
export * from "./ProviderTableSelection.vue?vue&type=script&lang=js"
import style0 from "./ProviderTableSelection.vue?vue&type=style&index=0&id=8fe74f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports